<template>
  <li
    class="flex gap-2 p-2 text-fg-base-fg3 cursor-pointer"
    :class="{
      'bg-surf-neut-soft-hov': isHovered,
      'opacity-50': item.disabled
    }"
    :title="item.title!"
    @mouseenter="isHovered = true"
    @mouseleave="isHovered = false"
  >
    <wui-icon
      v-if="item.icon"
      :name="isLoading ? 'spinner' : item.icon"
      small
      class="text-fg-base-fg22"
      :class="{
        'text-fg-base-fg3': isHovered,
        'text-warning-shades-900!': item.id === 'kickMember'
      }"
    />
    <div
      v-else
      class="w-4 h-4"
    />
    <span class="truncate">{{ item.label }}</span>
  </li>
</template>

<script setup lang="ts">
import { WuiIcon } from '@wui/common-library'
import { ref } from 'vue'

import { CallSessionMemberMenuItem } from '..'

defineProps<{
  item: CallSessionMemberMenuItem,
  isLoading?: boolean
}>()

const isHovered = ref(false)
</script>
